<template>
  <v-flex xs12 sm12 class="approve-section">
    <v-layout row wrap class="dismiss-section" @click="dismiss()"></v-layout>
    <v-layout row wrap class="popup-section">
      <v-flex xs12 sm12 mx-3 py-3 class="profile-section">
        <div
          class="profile-image"
          :style="{ 'background-image': 'url(' + item.avatar.url + ')' }"
        ></div>
        <div class="info-section">
          <div class="user-name">{{ item.username }}</div>
          <div class="user-slug">@{{ item.slug }}</div>
          <div class="status">{{ item.status }}</div>
        </div>
        <div class="mt-5 mb-3 info-user">
          <div class="font-weight-700">EMAIL</div>
          <div class="font-weight-500">{{ item.email }}</div>
        </div>
        <div class="mb-3 info-user">
          <div class="font-weight-700">LOCATION</div>
          <div class="font-weight-500">{{ userFullAddress }}</div>
        </div>
        <div class="mb-3 info-user">
          <div class="font-weight-700">AGE GROUP</div>
          <div class="font-weight-500">{{ item.gender }}</div>
        </div>
        <div class="mb-3 info-user">
          <div class="font-weight-700">SOCIAL PROFILE</div>
          <div
            v-if="
              (item.social_user_name || item.social_user_id) &&
              item.social_provider.toLowerCase() === 'instagram'
            "
            class="font-weight-500"
          >
            <span>Instagram - </span>
            <a
              :href="`https://instagram.com/${
                item.social_user_name == null
                  ? item.social_user_id
                  : item.social_user_name
              }`"
              target="_blank"
            >
              {{
                item.social_user_name == null
                  ? item.social_user_id
                  : item.social_user_name
              }}
            </a>
          </div>
          <div
            v-if="
              (item.social_user_name || item.social_user_id) &&
              (item.social_provider.toLowerCase() === 'tiktok' ||
                item.social_provider.toLowerCase() === 'tik tok')
            "
            class="font-weight-500"
          >
            <span>TikTok - </span>
            <a
              :href="`https://tiktok.com/${
                item.social_user_name == null
                  ? item.social_user_id
                  : item.social_user_name
              }`"
              target="_blank"
            >
              {{
                item.social_user_name == null
                  ? item.social_user_id
                  : item.social_user_name
              }}
            </a>
          </div>
          <div
            v-if="
              (item.social_user_name || item.social_user_id) &&
              item.social_provider.toLowerCase() === 'facebook'
            "
            class="font-weight-500"
          >
            <span>Facebook - </span>
            <a
              :href="`https://facebook.com/${
                item.social_user_name == null
                  ? item.social_user_id
                  : item.social_user_name
              }`"
              target="_blank"
            >
              {{
                item.social_user_name == null
                  ? item.social_user_id
                  : item.social_user_name
              }}
            </a>
          </div>
          <div
            v-if="
              (item.social_user_name || item.social_user_id) &&
              item.social_provider.toLowerCase() === 'twitter'
            "
            class="font-weight-500"
          >
            <span>Twitter - </span>
            <a
              :href="`https://twitter.com/${
                item.social_user_name == null
                  ? item.social_user_id
                  : item.social_user_name
              }`"
              target="_blank"
            >
              {{
                item.social_user_name == null
                  ? item.social_user_id
                  : item.social_user_name
              }}
            </a>
          </div>
        </div>
        <div class="flagged mb-5">Flagged</div>
        <div class="reason-flag">
          <div class="reason-flag__title">Reason for flag?</div>
          <v-select
            :items="denial_reasons"
            v-model="item.denial_reason"
            class="normal-input pt-2"
            style="max-width: 100%"
            autocomplete
          ></v-select>
        </div>
        <div class="action-section">
          <v-btn
            color="black"
            class="deny-btn"
            :loading="loading"
            @click.native="submission(item)"
            >Submit</v-btn
          >
          <v-btn
            color="black"
            class="deny-btn"
            outline
            >Cancel</v-btn
          >
        </div>
      </v-flex>
      <!-- <v-flex xs12 sm12>
          <v-text-field
            multi-line
            label="Leave specific message about why the user was denied."
            v-model="item.denial_description"
            class="normal-input"
            full-width
            style="max-width: 100%"
          ></v-text-field>
        </v-flex> -->
    </v-layout>
  </v-flex>
</template>

<script type="text/javascript">
export default {
  components: {},

  props: {
    item: {
      type: Object,
      required: true,
    },

    dismiss: {
      type: Function,
      required: true,
    },

    submission: {
      type: Function,
      required: true,
    },
    loading: null,
  },

  data() {
    return {
      denial_reasons: [
        "Did not complete application",
        "Music was not mixed/mastered",
        "Music was not your own",
        "Currently not accepting submissions",
        "Other reason",
      ],
    };
  },

  computed: {
    userFullAddress() {
      return `${_.get(this.item, 'city', '')}, ${_.get(
        this.item,
        'country',
        ''
      )}`
    },
  },

  created() {},

  methods: {},
};
</script>



// WEBPACK FOOTER //
// signup_deny_modal.vue?4fa07a82